/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import './Groups.less';
import { Actions } from '@vantiva-sa/homesight_humaui/Utilities/Constants';
import { GroupsIcon, ContactImage } from '../Common/Icons';
import { Spin, Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { truncateStringWith3Dots } from '@vantiva-sa/homesight_humaui/Utilities/CommonUtilities';
import { useSelector } from 'react-redux';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';

const ListItem = ({
  parentBread,
  onActionClick,
  title,
  count,
  record,
  members = [], // New prop for member data
}) => {
  const header = parentBread || [];
  const trans = useSelector(translator);
  const userGroupApi = useSelector((state) => state.apis.userGroupApi);

  const onClickHandler = () => {
    fetchLatestGroupInfo(record?.groupuuid);
  };

  const fetchLatestGroupInfo = (groupid) => {
    const groupuuid = groupid || null;

    const handleSuccess = (data) => {
      const updatedRecord = data?.usergroup;
      onActionClick(Actions.viewGroupDetails, updatedRecord, false)();
    };
    const handleError = (error) => {
      console.error('Error on group member add:', error);
    };

    userGroupApi.getUserGroupById(
      groupuuid,
      apiCallback({
        translator: trans,
        failCallback: handleError,
        errorCallback: handleError,
        successCallback: handleSuccess,
      })
    );
  };

  // Show first 3 members, then show dots if more than 3
  const displayMembers = members.slice(0, 3);
  const hasMoreMembers = members.length > 3;

  return (
    <>
      <div className="group-list-item" onClick={onClickHandler}>
        <div className="group-list-item-title">{truncateStringWith3Dots(title, 30)}</div>
        <div className="group-list-item-members">
          {displayMembers.map((member, index) => (
            <div key={index} className="user-image-container">
              <Avatar
                size={60}
                src={member?.profile_image_url}
                icon={<UserOutlined />}
                className="group-member-avatar"
              />
            </div>
          ))}
          {hasMoreMembers && (
            <div className="user-image-container">
              <div className="user-image more-members-indicator">
                <span className="dots-text">•••</span>
              </div>
            </div>
          )}
        </div>
        <div className="group-list-item-counts">
          <GroupsIcon className="new-ui-icon" />
          <span>{count}</span>
        </div>
      </div>
    </>
  );
};

export default ListItem;
